import React from "react";
import { ReconcilliationView } from "../View/ReconcilliationView";
interface IReconDetails {
  isEdit: boolean;
  rowData: any;
}

const ReconcilliationDetails: React.FC<IReconDetails> = ({
  isEdit,
  rowData,
}) => {
  return (
    <>
      <div className="mt-2 bg-white p-4 box-shadow rounded-md ">
        <div className="text-quinary pb-4 font-bold ">Vendor Information</div>
        <div className="grid grid-cols-3 items-center">
          <div className="self-start">
            <div className="expandedLabelVIP fontExpand ml-2">
              {rowData?.vendorName}
            </div>
            <div>
              <div className="expandedDataVIP fontExpand ml-2">
                {rowData?.vendorCode}
              </div>
            </div>
          </div>
          <div className="">
            <div className="expandedLabelVIP fontExpand ml-4">
              {rowData?.officeName}
            </div>
            <div className="expandedLabelVIP fontExpand ml-4">
              {rowData?.officeStreet}, {rowData?.officeCity},{" "}
              {rowData?.officeStateCode}
            </div>
            <div className="expandedLabelVIP fontExpand ml-4">
              {rowData?.officeZipcode}
            </div>
          </div>
          <div className="self-start">
            <div className="expandedLabelVIP fontExpand ml-4">
              Vendor ID: {rowData?.vendorCode}
            </div>
            <div className="expandedLabelVIP fontExpand ml-4">
              Address Code: {rowData?.vendorCode}
            </div>
          </div>
        </div>
      </div>
      <div className=" mt-2 bg-white p-4 box-shadow rounded-md  ">
        <div className="flex flex-row justify-between">
          <div className="font-bold text-quinary ">Invoice Details</div>
        </div>
        <ReconcilliationView isEdit={isEdit} rowData={rowData} />
      </div>
    </>
  );
};

export default ReconcilliationDetails;
